export { SEO } from './SEO'
export type { SEOProps } from './SEO'
